var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKezdlapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 40,
    viewBox: "0 0 48 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.7202 11.3862C45.3677 11.3862 48.0003 14.7193 48.0003 18.4767C48.0003 22.2342 45.3677 25.5672 41.7202 25.5672C38.0727 25.5672 35.4502 22.2342 35.4502 18.4767C35.4502 14.7193 38.0828 11.3862 41.7202 11.3862Z",
    fill: "#7C6CC9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6414 0C35.2888 0 37.9214 3.33305 37.9214 7.0905C37.9214 10.8479 35.2888 14.181 31.6414 14.181C27.9939 14.181 25.3613 10.8479 25.3613 7.0905C25.3613 3.33305 27.9939 0 31.6414 0Z",
    fill: "#7C6CC9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.991 0C13.3435 0 10.7109 3.33305 10.7109 7.0905C10.7109 10.8479 13.3435 14.181 16.991 14.181C20.6384 14.181 23.271 10.8479 23.271 7.0905C23.271 3.33305 20.6384 0 16.991 0Z",
    fill: "#7C6CC9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28006 11.3862C2.6326 11.3862 0 14.7296 0 18.4871C0 22.2445 2.6326 25.5776 6.28006 25.5776C9.92751 25.5776 12.5501 22.2445 12.5501 18.4871C12.5501 14.7296 9.92751 11.3862 6.28006 11.3862Z",
    fill: "#7C6CC9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4955 39.603C37.5803 37.9779 40.6249 32.3573 39.5799 28.9518C38.9468 26.8816 35.3195 26.2605 33.6414 24.8838C30.627 22.3892 28.2456 15.6506 24.3671 15.5678C20.2674 15.4747 17.5344 22.4927 14.319 25.0598C12.7414 26.3019 9.4356 26.8401 8.79253 28.7758C7.70733 32.026 10.4304 37.5328 13.3242 39.2511C16.2181 40.9694 21.0311 37.9262 24.3771 37.9986C27.4116 38.0711 31.7524 41.0522 34.4955 39.603Z",
    fill: "#7C6CC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKezdlapIcon);
export default __webpack_public_path__ + "static/media/KezdőlapIcon.9b3d6c56f458b27be1efa39dbccd4a32.svg";
export { ForwardRef as ReactComponent };